export const initialTimezonesStore = {
  data: {
    timezones: [],
  },
};
